<div class="loader-container">
  <div class="mesh-loader">
    <div class="set-one">
      <div class="circle" [ngClass]="spinnerClass"></div>
      <div class="circle" [ngClass]="spinnerClass"></div>
    </div>
    <div class="set-two">
      <div class="circle" [ngClass]="spinnerClass"></div>
      <div class="circle" [ngClass]="spinnerClass"></div>
    </div>
  </div>
</div>
